module.exports = __WEBPACK_EXTERNAL_MODULE__8823__;